module["exports"] = [
  "#{prefix} #{first_name} #{last_name} #{last_name}",
  "#{first_name} #{last_name} de #{last_name}",
  "#{suffix} #{first_name} #{last_name} #{last_name}",
  "#{first_name} #{last_name} #{last_name}",
  "#{first_name} #{last_name} #{last_name}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es_MX/name/name.js
 ** module id = 655
 ** module chunks = 0
 **/